import { Component, Input, OnInit } from '@angular/core';
import { Jumbotron } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-jumbotron',
  templateUrl: './sample-jumbotron.component.html',
  styleUrls: ['./sample-jumbotron.component.scss']
})
export class SampleJumbotronComponent implements OnInit {

  @Input() block: Jumbotron = {} as Jumbotron;
  public domainWebsite = environment.urlApi;
  public imgPath = "";
  public isLinkEsternal: boolean = false;

  constructor(
    private helperService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isLinkEsternal = this.block.link_cta ? this.helperService.verifyLinkExternal(this.block.link_cta.url) : false;
    this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.block.immagine, "src");
  }

}
